const Form = require("components/forms/Form");
const Section = require("components/forms/Section");
const CheckboxGroup = require("components/forms/CheckboxGroup");
const Checkbox = require("components/forms/Checkbox");
const Input = require("components/forms/Input");
const store = require("stores/UserStore");
const env = require("services/env");
const Confirm = require("components/modals/Confirm");
const CreditCard = require("components/forms/CreditCard");
const router = require("services/router");

class TeacherSettingsForm extends Form {

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get successMessage() {
		return "Dine indstillinger er blevet opdateret.";
	}

	get actionLabel() {
		return "Gem";
	}

	get shouldWarn() {
		return true;
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	send(form) {
		return this.creditCard.handle().then(() => {
			return store.save(new FormData(form)).then((response) => {
				// Clear password inputs
				Array.from(form.querySelectorAll("input[type=password]")).forEach(input => input.value = "");
				return response;
			});
		});
	}

	value(name) {
		return store.get(name);
	}

	onTeacherClick = (e) => {
		e.preventDefault();
		e.stopPropagation();

		const awaitBody = (
			<React.Fragment>
				<p>Du er nu ved at anmode om at blive underviser.</p>
				<p>Inden du kan foretage undervisning skal du udfylde ekstra information på din profil, hvorefter du kan sende din anmodning til godkendelse.</p>
				<p>Som underviser kan du stadig booke undervisning som elev.</p>
				<p>Er du klar til at blive underviser?</p>
			</React.Fragment>
		);

		return this.confirm
			.await(awaitBody, 'Oprettelse som underviser')
			.then(() => store.upgrade())
			.then(() => window.location.href = router.route('backend.profile'))
			.catch();
	}

	/////////////////////////////////
	// Renderers
	/////////////////////////////////

	renderBody() {
		return (
			<div className="form-body">
				<Section title="Betalingsoplysninger" contentClassName="flex">
					<CreditCard ref={el => this.creditCard = el} label="Kortoplysninger" name="card_token"
										afterChange={this.setWarning}
										currentCardType={this.value("card_brand")}
										currentCardDigits={this.value("card_last_four")}/>
				</Section>

				<Section title="Noftifikationer">
					<CheckboxGroup>{this.renderNotificationOptions()}</CheckboxGroup>
				</Section>

				<Section title="Skift adgangskode" contentClassName="flex column">
					<Input type="password" label="Nuværende Adgangskode" name="password[current]" error={this.error("password.current")}/>
					<Input type="password" label="Ny Adgangskode" name="password[value]" error={this.error("password.value")}/>
					<Input type="password" label="Bekræft ny adgangskode" name="password[confirmation]"
								 error={this.error("password.confirmation")}/>
				</Section>

				<Section title="Bliv underviser">
					<a href='javascript:void()' onClick={this.onTeacherClick} className="btn">Bliv underviser</a>
				</Section>
				<Confirm ref={el => this.confirm = el}/>
			</div>
		);
	}

	renderNotificationOptions() {
		const options = env.get("options.notificationOptions", {});
		const userOptions = this.value("options", []);
		const isChecked = option => {
			const opt = userOptions.filter(userOpt => userOpt.name === `${option}_notifications`) [0];
			return (opt == undefined) || (opt.value === true);
		};

		return Object.keys(options).map(option => {
			return (
				<Checkbox key={option} name={`${option}_notifications`} label={options[option]} checked={isChecked(option)}/>
			);
		});
	}

}

module.exports = TeacherSettingsForm;



// WEBPACK FOOTER //
// ./resources/js/components/backend/StudentSettingsForm.js